module.exports = __webpack_public_path__ + "static/images/wechat_logo.c9c3b69.png";